module.exports = __webpack_public_path__ + "assets/img/swiper-1.ac3ac5d7.jpg";